import {
  takeLatest, call, put,
} from 'redux-saga/effects';
import axios from '../axiosConfig';
import {
  getBrochureResponse, getBrochureRequest, getBrochureFail, updateBrochurePriceRequest,
} from '../../slices/brochure';
import { priceSuccess } from '../../slices/cruise';
import { setCruiseSearchParam } from '../../slices/tripSearch';
import getFiltersFromTrip from '../../../helpers/getFiltersFromTrip';
import getPriceBreakdownsFromBrochureTrip from '../../../helpers/getPriceBreakdownsFromBrochureTrip';

function* getBrochureWorker({
  payload: {
    id,
  },
}) {
  try {
    const url = `/brochure/get?id=${id}`;

    const config = {
      method: 'get',
      url,
    };
    const { data } = yield call(axios, config);
    if (data && data.id) {
      /// Assumed all trips in the brochure have same filters
      yield put(setCruiseSearchParam({
        filters: getFiltersFromTrip(data.trips[0]),
        // staterooms: getFiltersFromTrip(data.trips[0]).staterooms,
      }));
      for (let i = 0; i < data.trips.length; i += 1) {
        yield put(priceSuccess(getPriceBreakdownsFromBrochureTrip(data.trips[i])));
      }
      yield put(getBrochureResponse(data));
      if (data.doUpdatePriceOnPageLoad) {
        yield put(updateBrochurePriceRequest({ id: data.id }));
      }
    } else {
      yield put(getBrochureFail({ error: `Brochure not found related to ${id}.` }));
    }
  } catch (error) {
    let errorMessage = 'There is problem with your request. please try again.';
    if (error && error.response && error.response.data) {
      errorMessage = `${error.response.data.title} ${error.response.data.detail}`;
    }
    yield put(getBrochureFail({
      error: errorMessage,
    }));
  }
}

function* getBrochureWatcher() {
  yield takeLatest(getBrochureRequest.toString(), getBrochureWorker);
}

export default getBrochureWatcher;
